import type { FaireProductEntity } from "../../entity_types/product";

export const p_5yb9875rgu: FaireProductEntity = {
  token: "p_5yb9875rgu",
  type: "product",
  name: "Elisha Sparkling Drink 12.3 fl oz (350ml) Cans Refreshing Bubbly Delicious Pineapple Flavor for Hydration & Enjoyment",
  brandToken: "b_p3ed87kb2a",
  brandName: "SaniLLC",
  imageUrl:
    "https://cdn.faire.com/fastly/272d8308068f62ddba431cd60ecdbdcc40aebbba376e4457131ebe985f4f6730.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/f3811e09603c125ee1ae166ea0b92640d400b1cc23ad78414be582ce89a7020f.jpeg",
    "https://cdn.faire.com/fastly/649cbde6265fcfe3b3425e62ec0059f1905bba960f5ad09ced5fa579a425d385.jpeg",
  ],
  priceDollars: 2.78,
  description:
    "Drinks Elisha Pineapple - Tropical Refreshment in Every Sip!\n\nIndulge in the pure, natural sweetness of tropical pineapples with Drinks Elisha Pineapple. Bursting with vibrant, juicy flavors, this refreshing beverage captures the essence of freshly picked pineapples, delivering a delightful, thirst-quenching experience in every bottle. Perfect for a hot summer day or as a flavorful companion to your meals, Drinks Elisha Pineapple is made from real fruit and contains no artificial preservatives or sweeteners.\n\nKey Features:\n\n * 100% Pineapple Goodness: Made from real, juicy pineapples to bring you authentic tropical flavors. \n * No Artificial Additives: Free from artificial flavors, colors, and preservatives. \n * Refreshing and Hydrating: A perfect balance of natural sweetness and tangy notes for a refreshing, tropical experience. \n * Ideal for Any Occasion: Enjoy it chilled on its own, or mix it into cocktails and mocktails for a flavorful twist. \nIngredients: Pure Pineapple Juice, Water, Natural Fruit Extracts.\n\nBring a taste of the tropics to your day with Drinks Elisha Pineapple, your go-to drink for natural refreshment!\n",
  tags: [],
  msrpDollars: 3.48,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:55:12.746Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
